var canvas, canvas2, text, newText, zoom, cWidth = 1000, cHeight = 1429,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var sizeBmW = 715, sizeBmH = 450;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');



let frameImg = document.querySelector("#frame_design");
let frameDesign = new fabric.Image(frameImg, {
  left: 0,   
  top: 0,
  scaleX: 1.4,
  scaleY: 1.4,
  selectable: false
});

window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

window['canvas2'].add(frameDesign);
addModify(window['canvas2']);


window['text1Page'] = new fabric.Text('check',{
  left: 500,
  top: 730,
  fontSize: 54,
  fontFamily: 'Jameel Noori',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text1Page']);

// Clear text on input focus if default
document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'احمد علی') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 54; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_1').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text1Page'].set('text', newText);
  fitTextToWidth(window['text1Page'], 450);
  window['text1Page'].bringToFront();
  window['canvas2'].renderAll();
});



window['text2Page'] = new fabric.Text('check',{
  left: 500,
  top: 835,
  fontSize: 54,
  fontFamily: 'Jameel Noori',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

// Add to canvas
window['canvas2'].add(window['text2Page']);

// Clear text on input focus if default
document.getElementById('text_2').addEventListener('focus', function () {
  if (window['text2Page'].text === 'فریحہ عرفان') {
    window['text2Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth2(textObj, maxWidth) {
  let fontSize = 54; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_2').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text2Page'].set('text', newText);
  fitTextToWidth2(window['text2Page'], 450);
  window['text2Page'].bringToFront();
  window['canvas2'].renderAll();
});


var maxWidth = 630;
var maxHeight = 80;

window['text3Page'] = new fabric.Text('HAS BEEN SOLEMNIZED IN ACCORDANCE WITH THE REQUIREMENTS OF ISLAMIC LAW.\nAS ENSURINED BY THE QURAN AND THE SUNNAH OF THE PROPHET S.A.W.\nWITH THE AGREED MAHR, IN PRESENCE OF THE MARRIAGE OFFICER AND WITNESSESS',{
  left: 490,
  top: 920,
  width: 630,
  fontSize: 14,
  fontFamily: 'Times New Roman',
  fill: '#000',
  fontWeight: 'bold',
  lineHeight:1,
  textAlign: 'center',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName = window['text3Page'].fontFamily;
jQuery('.choose_font3').val("'" + fontName + "'").trigger('change');

window['canvas2'].add(window['text3Page']);


var minFontSize = 10;
var maxFontSize = 22;

// Clear text on input focus if default
document.getElementById('text_3').addEventListener('focus', function () {
  if (window['text3Page'].text === 'HAS BEEN SOLEMNIZED IN ACCORDANCE WITH THE REQUIREMENTS OF ISLAMIC LAW.\nAS ENSURINED BY THE QURAN AND THE SUNNAH OF THE PROPHET S.A.W.\nWITH THE AGREED MAHR, IN PRESENCE OF THE MARRIAGE OFFICER AND WITNESSESS') {
    window['text3Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText2(textbox, maxW, maxH) {
  let fontSize = maxFontSize;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_3').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text3Page'].set({
    text: input
  });
  fitTextToBox(window['text3Page'], maxWidth, maxHeight);
});

function fitTextToBox(textObj, maxWidth, maxHeight) {
  let fontSize = maxFontSize;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth || textObj.height > maxHeight;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}



window['text4Page'] = new fabric.Text('check',{
  left: 500,
  top: 997,
  fontSize: 45,
  fontFamily: 'Jameel Noori',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName = window['text4Page'].fontFamily;
jQuery('.choose_font4').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text4Page']);

// Clear text on input focus if default
document.getElementById('text_4').addEventListener('focus', function () {
  if (window['text4Page'].text === '۲۰۲۵, ستمبر ۱۳') {
    window['text4Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 45; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_4').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text4Page'].set('text', newText);
  fitTextToWidth(window['text4Page'], 350);
  window['text4Page'].bringToFront();
  window['canvas2'].renderAll();
});



window['text5Page'] = new fabric.Text('check',{
  left: 500,
  top: 1085,
  fontSize: 45,
  fontFamily: 'Jameel Noori',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

// Add to canvas
window['canvas2'].add(window['text5Page']);

// Clear text on input focus if default
document.getElementById('text_5').addEventListener('focus', function () {
  if (window['text5Page'].text === '۱۴۴۷ ربیع الاول ۲۱ ,(هجري)') {
    window['text5Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth2(textObj, maxWidth) {
  let fontSize = 45; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_5').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text5Page'].set('text', newText);
  fitTextToWidth2(window['text5Page'], 350);
  window['text5Page'].bringToFront();
  window['canvas2'].renderAll();
});



window['text6Page'] = new fabric.Text('City of Hyderabad (Karachi)',{
  left: 500,
  top: 1130,
  fontSize: 22,
  fontFamily: 'Times New Roman',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

// Add to canvas
window['canvas2'].add(window['text6Page']);

// Clear text on input focus if default
document.getElementById('text_6').addEventListener('focus', function () {
  if (window['text6Page'].text === 'City of Hyderabad (Karachi)') {
    window['text6Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth6(textObj, maxWidth) {
  let fontSize = 22; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_6').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text6Page'].set('text', newText);
  fitTextToWidth6(window['text6Page'], 310);
  window['text6Page'].bringToFront();
  window['canvas2'].renderAll();
});


window['text7Page'] = new fabric.Text('Corresponding to',{
  left: 500,
  top: 1035,
  fontSize: 22,
  fontFamily: 'Monotype Corsiva',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

// Add to canvas
window['canvas2'].add(window['text7Page']);


window['text8Page'] = new fabric.Text('and',{
  left: 500,
  top: 780,
  fontSize: 27,
  fontFamily: 'Times New Roman',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

// Add to canvas
window['canvas2'].add(window['text8Page']);




function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  jQuery(window).on('load',function(){
    canvasBlock(canvas);
  });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}



jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];
  activeOb.set({ fontFamily: this.value });
  fontFamily = jQuery(this).val();
  canvas.renderAll();
  updateFont(window['text1Page'],fontFamily);
  updateFont(window['text2Page'],fontFamily);
  fitTextToWidth(window['text1Page'], 450);
  fitTextToWidth2(window['text2Page'], 450);
});


jQuery(document).on('change','.fontFamily2',function(){
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];
  activeOb.set({ fontFamily: this.value });
  canvas.renderAll();
  fitTextToBox(window['text3Page'], maxWidth, maxHeight);
});


jQuery(document).on('change','.fontFamily3',function(){
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];
  activeOb.set({ fontFamily: this.value });
  fontFamily = jQuery(this).val();
  canvas.renderAll();
  updateFont(window['text4Page'],fontFamily);
  updateFont(window['text5Page'],fontFamily);
  fitTextToWidth(window['text4Page'], 350);
  fitTextToWidth2(window['text5Page'], 350);
});

function updateFont(activeOb,family){
  if(activeOb){
    if(family == ''){
      family = activeOb.fontFamily;
    }
    sCAle = activeOb.scaleX;
    activeOb.set('fontFamily',family);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}



jQuery(window).on('load',function(){
  canvasBlock(canvas2);
  window['text1Page'].set('text','احمد علی');
  window['text2Page'].set('text','فریحہ عرفان');
  window['text4Page'].set('text','۲۰۲۵, ستمبر ۱۳');
  window['text5Page'].set('text','۱۴۴۷ ربیع الاول ۲۱ ,(هجري)');
  window['canvas2'].renderAll();
  // loadFirstImg();
});


function getCookie(name){
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++){
    let cookie = cookies[i].trim();
    if(cookie.indexOf(nameEQ) === 0){
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.addEventListener("load", function(){
  if(getCookie("firstVisit")){
    console.log("✅ Cookie exists:", getCookie("firstVisit"));
  } else{
    console.log("❌ Cookie does not exist!");
    document.cookie = "firstVisit=lamaPao; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
    location.reload();
  }
});

 

/* fetch Call */
var size,thumbnail;
var loadedObject,groomName,brideName,Font1,quoteText,Font2,enterDate,hijriDate,Font3,cityName,additionalInfo,frameColor, wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 350;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    window['canvas2'] = canvas.toDataURL('image/png');
    groomName = jQuery('.groom_name input').val();
    brideName = jQuery('.brige_name input').val();
    Font1 = jQuery('.choose_font option:selected').val();
    quoteText = jQuery('.enter_quotation textarea').val();
    Font2 = jQuery('.choose_font3 option:selected').val();
    enterDate = jQuery('.enter_date input').val();
    hijriDate = jQuery('.hijri_date input').val();
    Font3 = jQuery('.choose_font4 option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    cityName = jQuery('.city_name input').val();
    frameColor = jQuery('.frameColorBox').val();
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#groomName').val(groomName);
      jQuery('#brideName').val(brideName);
      jQuery('#Font1').val(Font1);
      jQuery('#quoteText').val(quoteText);
      jQuery('#Font2').val(Font2);
      jQuery('#enterDate').val(enterDate);
      jQuery('#hijriDate').val(hijriDate);
      jQuery('#Font3').val(Font3);
      jQuery('#cityName').val(cityName);
      jQuery('#addInfo').val(additionalInfo);
      jQuery('#selected_frameColor').val(frameColor);
      //console.log('Server response:', data);
      console.log('Server response:', data);
      jQuery('.product-form__buttons .product-form__submit').trigger('click');
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});

function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}